import { Component, inject, ChangeDetectionStrategy } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatMenuModule } from '@angular/material/menu';
import { TranslateModule } from '@ngx-translate/core';
import Keycloak from 'keycloak-js';

import { HeaderService } from 'projects/client/src/app/service/header.service';
import { SvgAssetComponent } from 'projects/design-system/components/svg-icon/svg-icon.component';

@Component({
	selector: 'app-admin-header',
	standalone: true,
	imports: [MatButtonModule, SvgAssetComponent, TranslateModule, MatMenuModule, MatIconModule],
	templateUrl: './admin-header.component.html',
	changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AdminHeaderComponent {
	protected readonly headerService = inject(HeaderService);
	protected readonly keycloakService = inject(Keycloak);
}
